/**
 * Check if a value is a valid number
 * Matches mobile's ui-react-native-core isNumber utility
 */
export const isNumber = (value: unknown): boolean => {
    return !!(value && +value - +value < 1);
};
